module.exports = __webpack_public_path__ + "static/ernstpulido-2386dd40901f3a89a54de05e3fd4f076.jpg";